// client\src\pages\SignIn\index.js
import React from 'react';
import { useSearchParams } from 'react-router-dom';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Link from '@mui/material/Link';
import Box from '@mui/material/Box';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Alert from '@mui/material/Alert';
import { useAuth } from '../../hooks/useAuth';

export default function SignIn() {
    const { handleSignIn, loading, error } = useAuth();
    const [searchParams] = useSearchParams();
    const returnURL = searchParams.get('returnURL') || '/';

    const onSubmit = (event) => {
        event.preventDefault();
        const email = event.target.email.value;
        const password = event.target.password.value;
        handleSignIn(email, password, returnURL);
    };

    return (
        <Container component="main" maxWidth="xs">
            <Box
                sx={{
                    marginTop: 8,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minHeight: '80vh',
                }}
            >
                <Avatar sx={{ m: 1, bgcolor: 'primary.main' }}>
                    <LockOutlinedIcon />
                </Avatar>
                <Typography component="h1" variant="h5" sx={{ mb: 2 }}>
                    Access Your Account
                </Typography>
                {/* Improved Alert */}
                {error && (
                    <Alert
                        severity="error"
                        sx={{
                            mb: 2,
                            width: '100%',
                            boxSizing: 'border-box',
                            padding: '8px 16px'
                        }}
                    >
                        {error}
                    </Alert>
                )}
                <Box component="form" onSubmit={onSubmit} noValidate sx={{ mt: 1, width: '100%' }}>
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        id="email"
                        label="Email Address"
                        name="email"
                        autoComplete="email"
                        autoFocus
                    />
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        name="password"
                        label="Password"
                        type="password"
                        id="password"
                        autoComplete="current-password"
                    />

                    {/* Forgot Password (Right-Aligned) */}
                    <Box sx={{ textAlign: 'right', width: '100%', mb: 1 }}>
                        <Link href="/forgot-password" variant="body2">
                            Forgot Password?
                        </Link>
                    </Box>

                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        sx={{ mt: 1, mb: 2, py: 1, textTransform: 'none', fontSize: "14px" }}
                        disabled={loading}
                    >
                        {loading ? "Signing In..." : "Sign In"}
                    </Button>

                    {/* Register Link (Center-Aligned) */}
                    {/* <Box sx={{ textAlign: 'center', width: '100%' }}>
                        <Link href="/register" variant="body2">
                            Don't have an Account? Register
                        </Link>
                    </Box> */}
                </Box>
            </Box>
        </Container>
    );
}
